import { render, staticRenderFns } from "./FormGLTransaction.vue?vue&type=template&id=7244c281"
import script from "./FormGLTransaction.vue?vue&type=script&lang=js"
export * from "./FormGLTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports